import {
    AccountStateLogService,
    AvailableAccountTypesService,
    CardsService,
    CommonCustomerAccountService,
    CustomerService,
    LiquidityAccountsService,
    PoolService,
    TariffsService,
    TransfersService,
    IBANService
} from './service';

import {BanksService} from './service/banks.service';
import {BackofficeReasonsService} from './service/backoffice.reasons.service';
import {BackofficeRangesService} from './service/backoffice.ranges.service';
import {BackofficePurposesService} from './service/backoffice.purposes.service';
import {BackofficeBusinessTypeCategoriesService} from "./service/backoffice-business-type-categories.service";
import {BackofficeReportTypesService} from "./service/backoffice-report-types.service";

export * from './entity';
export * from './service';

export const SHARED_API_PROVIDERS = [
    CustomerService,
    PoolService,
    CardsService,
    TransfersService,
    LiquidityAccountsService,
    TariffsService,
    BanksService,
    AvailableAccountTypesService,
    AccountStateLogService,
    BackofficeReasonsService,
    CommonCustomerAccountService,
    BackofficeRangesService,
    BackofficeBusinessTypeCategoriesService,
    IBANService,
    BackofficePurposesService,
    BackofficeReportTypesService
];



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/api/index.ts